import { FSA } from 'flux-standard-action';
import {
  SERVICE_FETCH_REQUESTED,
  SERVICE_FETCH_SUCCEEDED,
  SERVICE_FETCH_FAILED,
  SERVICE_SAVE_REQUESTED,
  SERVICE_SAVE_SUCCEEDED,
  SERVICE_SAVE_FAILED,
  SERVICE_DELETE_REQUESTED,
  SERVICE_DELETE_SUCCEEDED,
  SERVICE_DELETE_FAILED,
} from './action-types';

type state = {
  status: string;
  data: { [key: string]: any };
};

const initialState: state = {
  status: '',
  data: {},
};

export default function reducer(state = initialState, action: FSA<any, any>) {
  switch (action.type) {
    case SERVICE_FETCH_REQUESTED:
      return { ...state, status: 'loading' };
    case SERVICE_FETCH_SUCCEEDED: {
      let data = action.payload;

      if (__USE_FAKE_DATA__) {
        data = Object.values<any>(action.payload).reduce((agg, cur) => {
          agg[cur.id] = {
            ...cur,
            name: { en: 'Consultation' },
          };
          return agg;
        }, {});
      }

      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...data,
        },
      };
    }
    case SERVICE_FETCH_FAILED:
      return { ...state, status: 'failed' };

    case SERVICE_SAVE_REQUESTED:
      return {
        ...state,
        status: 'saving',
        data: {
          ...state.data,
          ...(action.payload || {}),
        },
      };
    case SERVICE_SAVE_SUCCEEDED:
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case SERVICE_SAVE_FAILED:
      return {
        ...state,
        status: 'failed',
        data: {
          ...state.data,
          ...action.payload,
        },
      };

    case SERVICE_DELETE_REQUESTED:
      return { ...state, status: 'deleting' };
    case SERVICE_DELETE_SUCCEEDED: {
      const { [action.payload]: _, ...nonDeleted } = state.data;
      return {
        ...state,
        status: 'done',
        data: {
          ...nonDeleted,
        },
      };
    }
    case SERVICE_DELETE_FAILED:
      return { ...state, status: 'failed' };

    default:
      return state;
  }
}
